import { useIsInternalUser } from 'hooks/useIsInternalUser';

export function Divider({ onlyForInternalUser = false }: { onlyForInternalUser?: boolean }) {
  const isInternal = useIsInternalUser();
  if (onlyForInternalUser && !isInternal) {
    return null;
  }
  return <hr className="dropdown-divider" />;
}
